import { render, staticRenderFns } from "./VerifactuSubsancionDialog.vue?vue&type=template&id=56922b2e&scoped=true"
import script from "./VerifactuSubsancionDialog.vue?vue&type=script&lang=js"
export * from "./VerifactuSubsancionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56922b2e",
  null
  
)

export default component.exports